import React from "react";
import ScanRow from "./ScanRow";
import "./ScanRow.scss";

const ScanSendOrderRow = props => {
  return <ScanRow isSendOrder={true} />;
};

export default ScanSendOrderRow;
